import script from "./UserDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDetail.vue?vue&type=script&setup=true&lang=js"

import "./UserDetail.vue?vue&type=style&index=0&id=54f17b98&lang=css"

const __exports__ = script;

export default __exports__